module.exports = __webpack_public_path__ + "img/amex.98036e7.png";